	export const PATH_HOME = '/';

	export const PATH_PUBLIC_IMAGES = '/images';
	export const PATH_DEFAULT_PROJECT = `${PATH_PUBLIC_IMAGES}/projects.svg`;

	export const PATH_SIGN_IN = '/login';
	export const PATH_SIGN_UP = '/sign-up';
	export const PATH_RECOVERY = '/account/recovery';

	export const PATH_ACCOUNT = '/account';
	export const PATH_ACCOUNT_PHONE_NUMBER = '/account/phone-number';
	export const PATH_ACCOUNT_EMAIL = '/account/email';

	export const PATH_ACCOUNT_PASSWORD = `${PATH_ACCOUNT}/password`;
	export const PATH_ACCOUNT_PASSPORT = `${PATH_ACCOUNT}/passport`;
	export const PATH_ACCOUNT_WORK_DATA = `${PATH_ACCOUNT}/work-data`;
	export const PATH_ACCOUNT_TYPE_CHANGES = `${PATH_ACCOUNT_WORK_DATA}/type/changes`;

	export const PATH_ACCOUNT_PRODUCT_SHORT = `${PATH_ACCOUNT}/search/short`;;
	export const PATH_ACCOUNT_PRODUCT_FULL = `${PATH_ACCOUNT}/search/full`;;

	export const PATH_ACCOUNT_PRODUCT_CART = `${PATH_ACCOUNT}/search/cart`;
	export const PATH_ACCOUNT_PRODUCT_CART_CREATE_END = '#create';
	export const PATH_ACCOUNT_PRODUCT_CART_CREATE = `${PATH_ACCOUNT_PRODUCT_CART}${PATH_ACCOUNT_PRODUCT_CART_CREATE_END}`;

	export const PATH_ACCOUNT_PRODUCT_ORDER = `${PATH_ACCOUNT}/orders`;

	export const PATH_ACCOUNT_PROVIDER_USER = `${PATH_ACCOUNT}/providers`;
	export const PATH_ACCOUNT_PROVIDER_USER_CREATE_END = '#create';
	export const PATH_ACCOUNT_PROVIDER_USER_CREATE = `${PATH_ACCOUNT_PROVIDER_USER}${PATH_ACCOUNT_PROVIDER_USER_CREATE_END}`;

	export const PATH_ACCOUNT_CLIENT = `${PATH_ACCOUNT}/clients`;
	export const PATH_ACCOUNT_CLIENT_CREATE_END = '#create';
	export const PATH_ACCOUNT_CLIENT_CREATE = `${PATH_ACCOUNT_CLIENT}${PATH_ACCOUNT_CLIENT_CREATE_END}`;

	export const PATH_USERS = '/users';
	export const PATH_USERS_CREATE_END = '#create';
	export const PATH_USERS_CREATE = `${PATH_USERS}${PATH_USERS_CREATE_END}`;

	export const PATH_USERS_TYPES = '/users-types';
	export const PATH_USERS_TYPES_CREATE_END = '#create';
	export const PATH_USERS_TYPES_CREATE = `${PATH_USERS_TYPES}${PATH_USERS_TYPES_CREATE_END}`;

	export const PATH_APPLICATION = '/applications';
	export const PATH_APPLICATION_CREATE_END = '#create';
	export const PATH_APPLICATION_CREATE = `${PATH_APPLICATION}${PATH_APPLICATION_CREATE_END}`;

	export const PATH_BRAND = '/brands';
	export const PATH_BRAND_CREATE_END = '#create';
	export const PATH_BRAND_CREATE = `${PATH_BRAND}${PATH_BRAND_CREATE_END}`;

	export const PATH_PROVIDER = '/providers';
	export const PATH_PROVIDER_CREATE_END = '#create';
	export const PATH_PROVIDER_CREATE = `${PATH_PROVIDER}${PATH_PROVIDER_CREATE_END}`;

	export const PATH_PROVIDER_BRAND = '/providers-brands';
	export const PATH_PROVIDER_BRAND_CREATE_END = '#create';
	export const PATH_PROVIDER_BRAND_CREATE = `${PATH_PROVIDER_BRAND}${PATH_PROVIDER_BRAND_CREATE_END}`;

	export const PATH_PROVIDER_PARSER_FILE = '/provider-parser-file';

	export const PATH_PRODUCT_SHORT = '/search/short';
	export const PATH_PRODUCT_FULL = '/search/full';

	export const PATH_PRODUCT_CART = '/search/cart';
	export const PATH_PRODUCT_CART_CREATE_END = '#create';
	export const PATH_PRODUCT_CART_CREATE = `${PATH_PRODUCT_CART}${PATH_PRODUCT_CART_CREATE_END}`;

	export const PATH_PROVIDER_USER = '/providers-users';
	export const PATH_PROVIDER_USER_CREATE_END = '#create';
	export const PATH_PROVIDER_USER_CREATE = `${PATH_PROVIDER_USER}${PATH_PROVIDER_USER_CREATE_END}`;

	export const PATH_APPLICATION_USER_RELATION = '/applications-users-relations';
	export const PATH_APPLICATION_USER_RELATION_CREATE_END = '#create';
	export const PATH_APPLICATION_USER_RELATION_CREATE = `${PATH_APPLICATION_USER_RELATION}${PATH_APPLICATION_USER_RELATION_CREATE_END}`;

	export const PATH_USERS_TYPES_HISTORY_UPDATE_END = '#update';

	export const PATH_SYSTEM_SETTINGS_TYPES = '/system-settings-types';
	export const PATH_SYSTEM_SETTINGS = '/system-settings';
	export const PATH_SYSTEM_SETTINGS_USERS = `${PATH_SYSTEM_SETTINGS}-users`;
	export const PATH_SYSTEM_SETTINGS_SHIFTS = `${PATH_SYSTEM_SETTINGS}-shifts`;
	export const PATH_SYSTEM_SETTINGS_REPORTS = `${PATH_SYSTEM_SETTINGS}-reports`;
	export const PATH_SYSTEM_SETTINGS_BOOKKEEPING = `${PATH_SYSTEM_SETTINGS}-bookkeeping`;
	export const PATH_SYSTEM_SETTINGS_CALENDAR_EVENTS = `${PATH_SYSTEM_SETTINGS}-google-calendar-events`;
	export const PATH_SYSTEM_SETTINGS_AMOCRM = `${PATH_SYSTEM_SETTINGS}-amocrm`;

	export const PATH_USER_CLIENT = '/clients';
	export const PATH_USER_CLIENT_CREATE_END = '#create';
	export const PATH_USER_CLIENT_CREATE = `${PATH_USER_CLIENT}${PATH_USER_CLIENT_CREATE_END}`;

	export const PATH_ERROR = '*';

	export const PATH_STATIC = `${process.env.REACT_APP_BACKEND_URL}/static`;
	export const PATH_STATIC_USER_IMAGES = `${PATH_STATIC}/users-images`;
	export const PATH_STATIC_USERS_PASSPORTS_FILES = `${PATH_STATIC}/users-passports-files`;
